module.exports = __webpack_public_path__ + "img/IT0000643849285.02c13591.png";